var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0_6205_6810)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6205_6810",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6205_6810",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6205_6810",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAZKADAAQAAAABAAAAZAAAAAAvu95BAAADb0lEQVR4Ae2du24UMRSGA6ShjISEBE3YEkQFHZCkoETiIXgIKENEwUvQ8BxUEKgoESWXAgQSEh1UXP6jZDUbZjUeO8feQ+azZO1kfDm/v3+Ps5vLem2NAgEIQAACECgjcKpsWPao14kRD9T+LNGndvNtBXicCHI90X7s5vVjzzBugmuJbhuJ9hbNpiGls7qO09UjECCLAIZk4arfGUPqM86KgCFZuOp3xpD6jLMiYEgWrvqdPV/2XpLcm6rnVc9kSr+r/rPMMd7dr46Y8P4/fX7p6y+q+6ofVEOUHal4qfpn4tVM2VZdWbF3+Y9Uf6tO3Yz5+o3Fnmqrn4AoVFfMjLkQHo+yeNhhanO1ozBkxlETFp+UxmarjRUHUV7pYVEA130e9j0lu5TsdZuK8j470jQH2CvHLFYl70NuTZNt0apv5I5azx2g/hcSY36q/W2iz0lpvqyFnB1YzMWBtqVNJYYMCbAg71Sr/yJn6Wra33yjkFcGwqZY9YaWbFm9SbjhRwBD/Fi6zIQhLhj9JsEQP5YuM2GIC0a/STDEj6XLTBjigtFvkpL3IanoM3VI/WFcao7/pd3W6lpqGGJvhlb+B2eulBpOxpbVEPaYUBgyhlLDPhjSEPaYUBgyhlLDPhjSEPaYUBgyhlLDPjVe9n6T/icN17DKUPcU/JyngBqGfJVA+4+oKZQ7WqSrIWxZwZ42GIIhwQgEk0OGYEgwAsHkkCEYEoxAMDlkCIYEIxBMDhmCIcEIBJNDhmBIMALB5JAhGBKMQDA5ZAiGBCMQTA4ZgiHBCASTQ4ZgSDACweSQIRgSjEAwOWQIhgQjEEwOGYIhwQgEk0OGYEgwAsHkkCEYEoxAMDlkCIYEIxBMDhmCIcEIBJNDhmBIMALB5JAhGBKMQDA5ZEgwQ0o+OMA+SnyozNTIJ8odEPoxBGpZW4khn5dNtHCPT5TrYKRYdT0Pr0q2rOcaa+eFUNIE7GyurFJiyEdFsANdKMME9tWcdXbI8HTDrdtq5sij/qk6tnNYNTZ2hGB2yT1vcB7AssTGmjGUPoE93Xrav133jh2XZIHJlC5TjMWuaslRUhrmU7Y0je2X83Sd6uMLMSjaphZt8HRy81CQHfOzsRjkBF9/19o+qZoZto1TIAABCEAAAhCAAAQgAAEIQAACEIAABCAwGQJ/AbFaU84rgQLmAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c29da25561515157ad318f0eefe88860.svg";
export { ForwardRef as ReactComponent };